import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const AuthContext = createContext(null);
const http = axios.create({ baseURL: API, withCredentials: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, object=logged

  const refresh = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: skip /me check while AuthCallback exchanges the Google session_id
    if (window.location.hash?.includes("session_id=")) return setUser(false);
    if (["/concorsi", "/accedi", "/i-miei-premi"].some((p) => window.location.pathname.startsWith(p))) return setUser(false);
    refresh();
  }, [refresh]);

  const login = (data) => setUser(data.user);
  const logout = async () => {
    try {
      await http.post("/auth/logout", {});
    } catch (err) {
      console.warn("Logout admin lato server non riuscito:", err);
    }
    setUser(false);
  };

  const value = useMemo(() => ({ user, login, logout, refresh }), [user, refresh]); // eslint-disable-line react-hooks/exhaustive-deps
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
